import { IAttributeConvert } from "./IAttributeConvert";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { ExportValue } from "./ExportValue";
import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import { Feature } from "ol";

/**
 * 画面サイズ（横幅）
 */
const VALUE_WIDTH = 470;

/**
 * 画面サイズ（縦幅）
 */
const VALUE_HEIGHT = 361;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "gen_traf_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "gen_traf_yyyyMMdd_HHmmss.csv";

/**
 * タイトル
 */
const VALUE_TITLE = "一般交通量調査（時間帯別交通量）";

/**
 * 一般交通量調査データ（時間帯別交通量）属性変換クラス
 */
export class GeneralTrafficTimeAttributeConvert implements IAttributeConvert {
  /**
   * 地物
   */
  feature: Feature;

  constructor(feature: Feature) {
    this.feature = feature;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FeatureType.GeneralTrafficTime;
  }

  /**
   * 画面用フォーマットに変換
   */
  getViewFormatData(): AttributeView {
    const properties = this.feature.getProperties();
    // 画面項目定義リスト
    const items = [
      {
        key: "交通量調査単位区間番号",
        value: properties["交通量調査単位区間番号"],
        isSimple: true,
      },
      { key: "道路種別", value: properties["道路種別"], isSimple: true },
      { key: "路線番号", value: properties["路線番号"], isSimple: true },
      {
        key: "昼間12時間自動車類交通量",
        value: properties["昼間12時間自動車類交通量"],
        isSimple: true,
      },
      {
        key: "24時間自動車類交通量",
        value: properties["24時間自動車類交通量"],
        isSimple: true,
      },

      {
        key: "都道府県指定市コード",
        value: properties["都道府県指定市コード"],
        isSimple: false,
      },
      {
        key: "調査交通量観測・非観測の別",
        value:
          properties["調査交通量観測・非観測の別"] +
          "（" +
          properties["調査交通量観測・非観測の別_名称"] +
          "）",
        isSimple: false,
      },
      {
        key: "個別調査観測値活用の別",
        value:
          properties["個別調査観測値活用の別"] +
          "（" +
          properties["個別調査観測値活用の別"] +
          "）",
        isSimple: false,
      },
      {
        key: "12・24時間観測の別",
        value:
          properties["12・24時間観測の別"] +
          "（" +
          properties["12・24時間観測の別"] +
          "）",
        isSimple: false,
      },
      {
        key: "上り・下りの別",
        value:
          properties["上り・下りの別"] +
          "（" +
          properties["上り・下りの別_名称"] +
          "）",
        isSimple: false,
      },
      {
        key: "車種区分",
        value: properties["車種区分"] + "（" + properties["車種区分"] + "）",
        isSimple: false,
      },

      {
        key: "自動車類交通量（台/時）7時台",
        value: properties["自動車類交通量（台/時）7時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）8時台",
        value: properties["自動車類交通量（台/時）8時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）9時台",
        value: properties["自動車類交通量（台/時）9時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）10時台",
        value: properties["自動車類交通量（台/時）10時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）11時台",
        value: properties["自動車類交通量（台/時）11時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）12時台",
        value: properties["自動車類交通量（台/時）12時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）13時台",
        value: properties["自動車類交通量（台/時）13時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）14時台",
        value: properties["自動車類交通量（台/時）14時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）15時台",
        value: properties["自動車類交通量（台/時）15時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）16時台",
        value: properties["自動車類交通量（台/時）16時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）17時台",
        value: properties["自動車類交通量（台/時）17時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）18時台",
        value: properties["自動車類交通量（台/時）18時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）19時台",
        value: properties["自動車類交通量（台/時）19時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）20時台",
        value: properties["自動車類交通量（台/時）20時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）21時台",
        value: properties["自動車類交通量（台/時）21時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）22時台",
        value: properties["自動車類交通量（台/時）22時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）23時台",
        value: properties["自動車類交通量（台/時）23時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）0時台",
        value: properties["自動車類交通量（台/時）0時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）1時台",
        value: properties["自動車類交通量（台/時）1時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）2時台",
        value: properties["自動車類交通量（台/時）2時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）3時台",
        value: properties["自動車類交通量（台/時）3時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）4時台",
        value: properties["自動車類交通量（台/時）4時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）5時台",
        value: properties["自動車類交通量（台/時）5時台"],
        isSimple: false,
      },
      {
        key: "自動車類交通量（台/時）6時台",
        value: properties["自動車類交通量（台/時）6時台"],
        isSimple: false,
      },
    ];
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues: AttributeValue[] = [];
    items.forEach((item) => {
      attributeValues.push(
        new AttributeValue(
          item.key,
          item.value ? item.value.toString() : null,
          item.isSimple
        )
      );
    });
    const attributeView = new AttributeView(
      attributeValues,
      VALUE_TITLE,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      VALUE_HEIGHT,
      null,
      true,
      true
    );
    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = this.feature.clone();
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
